import cx from 'classnames';
import FeedbackBg from "../../../../assets/images/feedback-bg.svg";

import styles from "./styles.module.scss";

const CheckSvgComponent = (props) => {
  const {width , className } = props;
  console.log(width,'wiwiiwiwiwiwi')
  return (<>
  <div className={styles["success-icon-wrapper"]}>
      <div className={cx(styles["success-icon"],className)}>
                <svg
                  className={styles["check-svg"]}
                  width={width || '64'}
                  height="64"
                  viewBox="0 0 100 100"
                >
                  <g className={styles["check-circle"]}>
                    <image
                      href={FeedbackBg}
                      x="0"
                      y="0"
                      width="100"
                      height="100"
                      preserveAspectRatio="xMidYMid meet"
                    />
                  </g>
  
                  <path
                    className={styles["check-path"]}
                    fill="none"
                    d="M30 52 L44 66 L72 36"
                  />
                </svg>
              </div>
       </div></>
  )
}

export default CheckSvgComponent